import { render, staticRenderFns } from "./export-list.vue?vue&type=template&id=b6484066&scoped=true"
import script from "./export-list.vue?vue&type=script&lang=js"
export * from "./export-list.vue?vue&type=script&lang=js"
import style0 from "./export-list.vue?vue&type=style&index=0&id=b6484066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6484066",
  null
  
)

export default component.exports